import QRCode from "react-qr-code";
import { Box, Typography, Container, Paper } from "@mui/material";
import { TERMS_AND_CONDITIONS, useScannerData } from "./scannerData";
import ACROSS_BANER_LOGO from "../../assets/images/AcrossLogo.png";
import GlobalModal from "../../components/Modal";
import video from "../../assets/video/apbQrTutorial.mp4";

const Scanner = () => {
  const {
    openModal,
    tncChecked,
    setTncChecked,
    qrCodeUrl,
    Styles,
    handleDialogClose,
    handleProceed,
  } = useScannerData();

  return (
    <Box sx={{ minHeight: "100vh", minWidth: "100vw", position: "relative" }}>
      <Box
        sx={{
          ...(openModal ? Styles.BlurBg : {}),
          zIndex: openModal ? 1 : "auto",
          position: openModal ? "fixed" : "relative",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          pointerEvents: openModal ? "none" : "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: openModal ? "#fff" : "none",
        }}
      >
        <Container maxWidth="sm" sx={Styles.ParentContainer}>
          <Box
            alt="Logo"
            component="img"
            sx={Styles.BannerLogo}
            src={ACROSS_BANER_LOGO}
            onError={(e) => {
              e.target.src = "https://via.placeholder.com/150x50?text=Logo";
            }}
          />

          <Typography variant="h5" gutterBottom sx={Styles.HeadingTxt}>
            <span role="img" aria-label="lock">
              🔒
            </span>{" "}
            <span style={{ color: "#000" }}>
              Secure Policy Submission Made Easy
            </span>
          </Typography>

          <Typography variant="body2" sx={Styles.DescriptionTxt}>
            <span style={{ color: "#000" }}>
              Just scan the QR code, provide your details, record a quick video,
              and your policy will be safely saved.
            </span>
          </Typography>

          <Paper
            elevation={3}
            sx={{
              ...Styles.QRCodeContainer,
              background: "#fff",
              boxShadow: "0 4px 24px 0 rgba(0,0,0,0.05)",
            }}
          >
            <QRCode
              value={qrCodeUrl}
              size={200}
              style={Styles.QRCodeScannerImg}
              fgColor="#000"
              bgColor="#fff"
            />
          </Paper>
        </Container>
      </Box>

      <GlobalModal
        open={openModal}
        onClose={handleDialogClose}
        onProceed={handleProceed}
        title={TERMS_AND_CONDITIONS.title}
        description={
          <span>
            Please read the <span style={{ color: "#000" }}>T&C</span> carefully
            before proceeding.
          </span>
        }
        video={video}
        items={TERMS_AND_CONDITIONS.items}
        conclusion={TERMS_AND_CONDITIONS.conclusion}
        checkboxLabel="I agree to the T&C"
        checkboxChecked={tncChecked}
        onCheckboxChange={setTncChecked}
        modalHeight="479px"
        videoWidth={230}
        videoHeight={233}
        contentSx={{
          "& video": {
            width: "230px",
            height: "233px",
            borderRadius: "8px",
            boxShadow: "0 2px 8px 0 rgba(0,0,0,0.08)",
            background: "#fff",
            objectFit: "contain",
          },
        }}
      />
    </Box>
  );
};

export default Scanner;
